var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.touchClass,on:{"touchstart":function($event){_vm.touchStart($event)},"touchend":function($event){_vm.touchEnd($event)},"touchmove":function($event){_vm.touchMove($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }